import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import lightbox from 'lightbox2';
import { initSwiperOnMount } from '../../gutenberg-swiper';

class BlockSliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    initSwiperOnMount('.slider-images__swiper', (element) => {
      new Swiper(element, {
        modules: [Navigation],
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 20,
        grabCursor: true,
        preventInteractionOnTransition: true,
        navigation: {
          prevEl: element.querySelector('.swiper-button-prev') as HTMLElement,
          nextEl: element.querySelector('.swiper-button-next') as HTMLElement,
        },
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            spaceBetween: 24
          },
          1025: {
            slidesPerView: 'auto',
            spaceBetween: 24
          }
        }
      });
    });

    lightbox.option({
      resizeDuration: 200,
      imageFadeDuration: 200,
      wrapAround: false,
      showImageNumberLabel: false,
      disableScrolling: true,
    });
  }
}

export const blockSliderMedias = new BlockSliderMedias();
